export const formatCurrency = (amount) => {
  const formattedNumber = Number(amount || 0).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  return `₹ ${formattedNumber}`;
};

export const formatShortAmount = (amount) => {
  const cleaned = String(amount ?? 0).replace(/[^0-9.-]/g, "");
  const num = Number(cleaned);
  if (isNaN(num)) return "0.00";

  if (num >= 1e7) {
    return (num / 1e7).toFixed(2) + "cr";
  } else if (num >= 1e5) {
    return (num / 1e5).toFixed(2) + "L";
  }
  return num.toFixed(2);
};
